import { DARK, LIGHT } from "constants/appModes";

export const createAppThemeInitialValues = {
  name: "Customization name",
  mode: LIGHT,
  svgLogo: null,
  logo: false,
  [LIGHT]: {
    name: "Light",
    primary: "#000000",
    pngLogo: null,
    gradient: ["#DB0000", "#000DC8"],
  },
  [DARK]: {
    name: "Dark",
    primary: "#FFFFFF",
    pngLogo: null,
    gradient: ["#6D0101", "#001582"],
  },
};
